<template>
  <div>
    <div class="flex items-start pt-20 bg-viva-blue">
      <div class="container pt-5 relative">
        <div class="flex justify-center gap-6 lg:hidden items-center">
          <img src="img/leads/logo-white.svg" alt="VIVA Finance" class="w-2/5" />
          <img
            v-if="this.imageName && this.imageExt"
            :src="affiliateLogo"
            alt="affiliate logo"
            class="w-2/5"
          />
        </div>
        <div class="flex pt-5 lg:pt-16 pb-4 lg:pb-20 px-4">
          <div class="w-full lg:w-2/5 card-shadow">
            <div class="bg-white rounded-lg">
              <div
                class="flex flex-col justify-center items-start bg-viva-green p-4 text-white rounded-t-lg"
              >
                <p class="text-2xl lg:text-4xl font-semibold">Hi There,</p>
                <p class="text-2xl lg:text-4xl font-semibold">check your loan offer!</p>
              </div>
              <div class="px-2 py-4">
                <div v-if="!$store.getters.verifying && !$store.getters.authenticated">
                  <div>
                    <transition name="in--up">
                      <div>
                        <Input
                          v-model="email"
                          type="text"
                          bg="gray-100"
                          name="Work Email"
                          placeholder="hello"
                          :setter="$setters.email"
                          class="w-full px-1"
                          :transitionsEnabled="false"
                          @enterClicked="enterNext"
                          :error="emailError"
                        />
                        <div class="flex justify-center mt-5 pl-1">
                          <button
                            class="mt-1 border border-gray-500 bg-gray-300 w-4 h-5 focus:outline-none focus:border-primary px-2 flex items-center justify-center"
                            aria-label="terms"
                            @click="terms.viva = !terms.viva"
                          >
                            <i
                              v-if="terms.viva"
                              class="fas fa-check text-sm font-bold text-green-500"
                            ></i>
                          </button>
                          <p class="ml-2 text-xs">
                            By signing up, I agree to the VIVA Finance
                            <router-link
                              to="terms"
                              class="underline text-blue-500 hover:text-secondary"
                              target="_blank"
                              rel="noopener"
                              >Terms of Service</router-link
                            >,
                            <router-link
                              to="privacy"
                              class="underline text-blue-500 hover:text-secondary"
                              target="_blank"
                              rel="noopener"
                              >Privacy Policy</router-link
                            >,
                            <router-link
                              to="tcpa"
                              class="underline text-blue-500 hover:text-secondary"
                              target="_blank"
                              rel="noopener"
                              >TCPA Communication Policy</router-link
                            >, and to the use of
                            <router-link
                              to="esign"
                              class="underline text-blue-500 hover:text-secondary"
                              target="_blank"
                              rel="noopener"
                              >Electronic Records and Signatures</router-link
                            >. I authorize VIVA Finance to confirm my income and employment using
                            <a
                              href="https://www.truework.com/products/employees/"
                              class="underline text-blue-500 hover:text-secondary"
                              target="_blank"
                              rel="noopener"
                              >Truework</a
                            >.
                          </p>
                        </div>
                        <div class="flex justify-center mt-3 pl-1">
                          <button
                            class="mt-1 border border-gray-500 bg-gray-300 w-4 h-5 focus:outline-none focus:border-primary px-2 flex items-center justify-center"
                            aria-label="terms"
                            @click="terms.employerRelease = !terms.employerRelease"
                          >
                            <i
                              v-if="terms.employerRelease"
                              class="fas fa-check text-sm font-bold text-green-500"
                            ></i>
                          </button>
                          <p class="ml-2 text-xs">
                            VIVA's loans are not provided by, sponsored, or endorsed by any
                            employer. VIVA Finance is an optional resource and employers in no way
                            benefit from VIVA's loans. VIVA Finance is not directly affiliated with
                            any employers and completely releases employers from any liability. By
                            checking this box, I understand and acknowledge this disclosure.
                          </p>
                        </div>
                        <div class="flex justify-center mt-3 pl-1">
                          <button
                            class="mt-1 border border-gray-500 bg-gray-300 w-4 h-5 focus:outline-none focus:border-primary px-2 flex items-center justify-center"
                            aria-label="terms"
                            @click="terms.dwolla = !terms.dwolla"
                          >
                            <i
                              v-if="terms.dwolla"
                              class="fas fa-check text-sm font-bold text-green-500"
                            ></i>
                          </button>
                          <p class="ml-2 text-xs">
                            By submitting, you also agree to VIVA's payment partner, Dwolla's
                            <a
                              target="_blank"
                              rel="noopener"
                              href="https://www.dwolla.com/legal/tos/"
                              class="underline text-blue-500 hover:text-secondary"
                              >Terms of Service</a
                            >
                            and
                            <a
                              target="_blank"
                              rel="noopener"
                              href="https://www.dwolla.com/legal/privacy/"
                              class="underline text-blue-500 hover:text-secondary"
                              >Privacy Policy</a
                            >
                            . Dwolla is a partner of Evolve Bank & Trust, member FDIC. By creating
                            an account, you also agree to Evolve's
                            <a
                              target="_blank"
                              rel="noopener"
                              href="https://www.dwolla.com/legal/virtual-account-number-personal-account-demand-deposit-agreement/#legal-content"
                              class="underline text-blue-500 hover:text-secondary"
                              >Customer Account Terms</a
                            >
                            and
                            <a
                              target="_blank"
                              rel="noopener"
                              href="https://assets.getevolved.com/cdnevolve/privacy-policy/Consumer-Privacy-Policy-Notice---9.15.20-Final.pdf"
                              class="underline text-blue-500 hover:text-secondary"
                              >Privacy Notice</a
                            >
                          </p>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
                <transition name="in--right">
                  <div v-if="$store.getters.verifying">
                    <p class="mb-4 font-medium text-sm lg:text-base">
                      A confirmation code was sent to
                      {{ alias.includes('@') ? alias : $getters.phone_number(email) }}. Please enter
                      the 6 digit code below or
                      <button
                        type="btn"
                        class="text-blue-500 underline"
                        aria-label="email change"
                        @click="$Auth.signOut()"
                      >
                        Change {{ alias.includes('@') ? 'email address' : 'phone number' }}
                      </button>
                    </p>
                    <Input
                      v-model="code"
                      bg="gray-100"
                      type="text"
                      name="Sign In Code"
                      maxlength="6"
                      :instantFocus="true"
                      placeholder="123456"
                      class="mb-3 text-sm lg:text-lg font-semibold w-64 text-center"
                      @enterClicked="enterNext"
                    />
                    <div>
                      <p class="pt-3 mb-4 font-medium text-sm">
                        <span v-if="alias.includes('@')" class="mr-2"
                          >Didn't receive an email? Be sure to check your junk/spam!</span
                        >
                        <span v-else class="mr-2">Didn't receive a Text?</span>
                        <button
                          aria-label="code"
                          class="text-sm text-blue-500 underline"
                          style="outline: none"
                          @click="
                            $Auth.signIn(alias).then((user) => {
                              $store.commit('updateUser', user)
                              $store.commit('applicationData/updateUser', user)
                            }),
                              (resend = true)
                          "
                        >
                          Resend code
                        </button>
                      </p>

                      <p v-if="resend === true" class="text-primary ml-2">
                        A new code has been sent<i
                          class="far fa-check-circle text-primary ml-2"
                        ></i>
                      </p>
                    </div>
                  </div>
                </transition>
                <div class="flex mt-10">
                  <Navigate
                    :back="back"
                    :disabled="_disabled"
                    :error="error"
                    :loading="loading"
                    :next="nextWrapper"
                    :step="step"
                    :verifying="verifying"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-3/5 hidden lg:block px-4">
            <div class="flex justify-center gap-6 items-center mb-3">
              <img src="img/leads/logo-white.svg" alt="VIVA Finance" class="w-2/5" />
              <img
                v-if="this.imageName && this.imageExt"
                :src="affiliateLogo"
                alt="affiliate logo"
                class="w-2/5"
              />
            </div>
            <img src="img/leads/people-desktop.svg" alt="VIVA Finance" class="w-full" />
            <div class="text-2xl text-white mt-5 p-4">
              <p class="mb-6"></p>
              <p v-if="this.welcomeGroup">Welcome {{ this.welcomeGroup }}!</p>
              <p v-if="this.company">
                {{ this.company }} members get a $20 credit toward your loan!
              </p>
              <p>Check your rate without impacting your credit score</p>
              <p>Receive funds as soon as next business day</p>
            </div>
          </div>
        </div>
        <div class="lg:hidden">
          <img src="img/leads/people-mobile.svg" alt="VIVA Finance" class="w-full my-2" />
          <div class="text-2xl text-white px-4 py-6">
            <p v-if="this.welcomeGroup">Welcome {{ this.welcomeGroup }}!</p>
            <p v-if="this.company">{{ this.company }} members get a $20 credit toward your loan!</p>
            <p class="mb-6">Check your rate without impacting your credit score</p>
            <p>Receive funds as soon as next business day</p>
          </div>
          <div class="relative">
            <img src="img/leads/bg-mobile.svg" alt="VIVA Finance" class="w-full" />
            <div class="absolute top-0 h-full">
              <div class="p-4 h-full">
                <p class="text-white text-xl font-bold mb-5">Why VIVA?</p>
                <ul>
                  <li class="flex items-start mb-3">
                    <img
                      src="img/leads/icon-brand.svg"
                      alt="VIVA Finance brand icon"
                      class="w-6 mr-5"
                    />
                    <span class="text-white text-lg"
                      >Affordable loans designed with your job in mind, not just your credit</span
                    >
                  </li>
                  <li class="flex items-start mb-3">
                    <img
                      src="img/leads/icon-brand.svg"
                      alt="VIVA Finance brand icon"
                      class="w-6 mr-5"
                    />
                    <span class="text-white text-lg"
                      >Seamless payments made through direct deposit</span
                    >
                  </li>
                  <li class="flex items-start">
                    <img
                      src="img/leads/icon-brand.svg"
                      alt="VIVA Finance brand icon"
                      class="w-6 mr-5"
                    />
                    <span class="text-white text-lg"
                      >On-time payments help to build your credit</span
                    >
                  </li>
                </ul>
                <div class="flex justify-center">
                  <div class="absolute bottom-0">
                    <img src="img/leads/person.svg" alt="VIVA Finance" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden lg:block lg:relative">
      <img src="img/leads/bg-desktop.svg" alt="VIVA Finance" class="w-full" />
      <div class="absolute top-0 h-full w-full">
        <div class="flex items-end justify-center h-full pt-4 md:pt-6 lg:pt-8">
          <img src="img/leads/person.svg" alt="VIVA Finance" />
          <div class="h-full">
            <p class="text-white text-xl font-bold mb-5">Why VIVA?</p>
            <ul>
              <li class="flex items-start mb-3">
                <img
                  src="img/leads/icon-brand.svg"
                  alt="VIVA Finance brand icon"
                  class="w-6 mr-5"
                />
                <span class="text-white text-lg"
                  >Affordable loans designed with your job in mind, not just your credit</span
                >
              </li>
              <li class="flex items-start mb-3">
                <img
                  src="img/leads/icon-brand.svg"
                  alt="VIVA Finance brand icon"
                  class="w-6 mr-5"
                />
                <span class="text-white text-lg"
                  >Seamless payments made through direct deposit</span
                >
              </li>
              <li class="flex items-start">
                <img
                  src="img/leads/icon-brand.svg"
                  alt="VIVA Finance brand icon"
                  class="w-6 mr-5"
                />
                <span class="text-white text-lg">On-time payments help to build your credit</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigate from '@/components/VIVA/Navigate.vue'
import Engine from '@/mixins/Engine'

export default {
  props: ['company', 'imageName', 'routePath', 'imageExt', 'welcomeGroup'],
  components: {
    Navigate
  },
  name: 'AffiliateLandingPage',
  mixins: [Engine],
  data() {
    return {
      green: false,
      toggled: true,
      sub: 'District School/Department',
      showDropdown: false,
      resend: false,
      close: false,
      internetExplorer: false,
      emailError: '',
      nextLoading: false,
      fieldOrder: ['given_name'],
      personalInformation: {
        given_name: {
          name: 'First name',
          placeholder: 'Jane',
          value: '',
          error: '',
          id: 'ner_first_name'
        }
      },
      leadFirstName: ''
    }
  },
  computed: {
    _disabled() {
      return !this.email
    },
    header() {
      if (this.$route.path.includes('login')) {
        return {
          h1: 'Sign In',
          h2: 'Enter your phone number or email address to sign in to your VIVA account.'
        }
      } else {
        return {
          h1: 'Create your Account',
          h2: (this.$route.query.redirect || '').includes('apply')
            ? 'Before continuing with your loan application, please create your account with VIVA Finance.'
            : 'Create your account with VIVA Finance.'
        }
      }
    },
    img() {
      if (this.$store.getters.verifying) {
        return 'verify'
      } else if (this.$route.path.includes('login')) {
        return 'login'
      } else {
        return 'createAccount'
      }
    },
    msie() {
      return this.internetExplorer
    },
    affiliateLogo() {
      return `img/leads/${this.imageName}-logo.${this.imageExt}`
    }
  },
  mounted() {
    this.step = 'creates'
    this.isIe()

    // to work with the Navigate disabled function on login

    this.terms.viva = this.$route.path.includes('login') ? true : false
    this.terms.employerRelease = this.$route.path.includes('login') ? true : false
    this.terms.dwolla = this.$route.path.includes('login') ? true : false
  },
  methods: {
    enterNext() {
      this.next()
    },
    nextWrapper() {
      if (!this.emailError) {
        console.log('this next')
        this.next()
      }
    },
    toggleInside() {
      this.toggled = true
    },
    toggleOutside() {
      this.toggled = false
    },
    isIe() {
      const ua = window.navigator.userAgent
      this.internetExplorer = ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1
    },
    signInInstead() {
      this.terms.viva = true
      this.terms.employerRelease = true
      this.terms.dwolla = true
      this.$router.push({ name: 'Login', query: this.$route.query })
    }
  },

  watch: {
    '$route.path': function (path) {
      this.error = ''
      this.terms.viva = path.includes('login') ? true : false
      this.terms.employerRelease = path.includes('login') ? true : false
      this.terms.dwolla = path.includes('login') ? true : false
    },

    email() {
      this.emailError = ''
    }
  }
}
</script>

<style></style>
